import { BellIcon } from "@heroicons/react/24/outline";
import { BellIcon as BellIconSolid } from "@heroicons/react/24/solid";
import React, { useContext, useState } from "react";
import { ThemeContext } from "../contexts/ThemeContext";

const mockNotifications = [
  { id: 1, text: "John Doe liked your post", read: false, timestamp: "2h ago" },
  {
    id: 2,
    text: "Jane Smith commented on your project",
    read: false,
    timestamp: "1d ago",
  },
  {
    id: 3,
    text: "New message from recruiter",
    read: true,
    timestamp: "3d ago",
  },
];

const Notifications = () => {
  const [notifications, setNotifications] = useState(mockNotifications);
  const [isOpen, setIsOpen] = useState(false);
  const { darkMode } = useContext(ThemeContext);
  const unreadCount = notifications.filter((n) => !n.read).length;

  const toggleNotifications = () => setIsOpen(!isOpen);

  const markAsRead = (id) => {
    setNotifications(
      notifications.map((n) => (n.id === id ? { ...n, read: true } : n))
    );
  };

  const markAllAsRead = () => {
    setNotifications(notifications.map((n) => ({ ...n, read: true })));
  };

  return (
    <div className="relative">
      <button onClick={toggleNotifications} className="relative">
        {unreadCount > 0 ? (
          <BellIconSolid className="w-6 h-6" />
        ) : (
          <BellIcon className="w-6 h-6" />
        )}
        {unreadCount > 0 && (
          <span className="absolute flex items-center justify-center w-4 h-4 text-xs text-white bg-red-500 rounded-full -top-1 -right-1">
            {unreadCount}
          </span>
        )}
      </button>
      {isOpen && (
        <div
          className={`absolute right-0 z-20 mt-2 overflow-hidden ${
            darkMode ? "bg-gray-900" : "bg-white"
          } rounded-md shadow-lg w-80`}
        >
          <div className="py-2">
            <div className="flex items-center justify-between px-4 py-2 border-b">
              <h3 className="text-lg font-semibold">Notifications</h3>
              <button onClick={markAllAsRead} className="text-sm text-blue-500">
                Mark all as read
              </button>
            </div>
            {notifications.map((notification) => (
              <div
                key={notification.id}
                className={`px-4 py-2 hover:bg-gray-100 ${
                  notification.read ? "opacity-50" : ""
                }`}
                onClick={() => markAsRead(notification.id)}
              >
                <p className="text-sm">{notification.text}</p>
                <p className="text-xs text-gray-500">
                  {notification.timestamp}
                </p>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default Notifications;
